import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Identity } from '@wajeez/wajeez.microservices';
import _ from 'lodash';

import {
  getFaqById,
  getFaqCtegories,
  getFaqsDataTable,
  createNewCategory,
  createNewFaq,
  editCategory,
  editFaq,
  deleteCategory,
  deleteFaq,
  getCategoryFaqs,
  createFaqEngagement,
} from './thunks';
import { FaqsState } from './types';

export const name = 'faqs';

const initialState: FaqsState = {
  data: null,
  details: null,
  faqsCategoriesData: [],
  categoryFaqs: {},
  status: 'idle',
  updatingStatus: 'idle',
  categoriesStatus: 'idle',
  updatingCategoriesStatus: 'idle',
  categoryFaqsStatus: 'idle',
  createFaqEngagement: { id: null, status: 'idle' },
};
export const createFaqEngagementAsync = createAsyncThunk(
  name + '/createFaqEngagement',
  createFaqEngagement
);
export const getCategoryFaqsAsync = createAsyncThunk(
  name + '/getCategoryFaqs',
  getCategoryFaqs
);
export const getFaqsDataTableAsync = createAsyncThunk(
  name + '/getFaqsDataTable',
  getFaqsDataTable
);
export const getFaqByIdAsync = createAsyncThunk(
  name + '/getFaqById',
  getFaqById
);
export const getFaqCtegoriesAsync = createAsyncThunk(
  name + '/getFaqCtegories',
  getFaqCtegories
);

export const createNewCategoryAsync = createAsyncThunk(
  name + '/createNewCategory',
  createNewCategory
);

export const createNewFaqAsync = createAsyncThunk(
  name + '/createNewFaq',
  createNewFaq
);

export const editCategoryAsync = createAsyncThunk(
  name + '/editCategory',
  editCategory
);

export const editFaqAsync = createAsyncThunk(name + '/editFaq', editFaq);

export const deleteCategoryAsync = createAsyncThunk(
  name + '/deleteCategory',
  deleteCategory
);

export const deleteFaqAsync = createAsyncThunk(name + '/deleteFaq', deleteFaq);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
    clearCreateFaqEngagementStatus: (state) => {
      state.createFaqEngagement = { id: null, status: 'idle' };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFaqsDataTableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFaqsDataTableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getFaqsDataTableAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getFaqByIdAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFaqByIdAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.details = action.payload;
      })
      .addCase(getFaqByIdAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getFaqCtegoriesAsync.pending, (state) => {
        state.categoriesStatus = 'loading';
      })
      .addCase(getFaqCtegoriesAsync.fulfilled, (state, action) => {
        state.categoriesStatus = 'idle';
        state.faqsCategoriesData = action.payload;
      })
      .addCase(getFaqCtegoriesAsync.rejected, (state) => {
        state.categoriesStatus = 'failed';
      })
      .addCase(createNewCategoryAsync.pending, (state) => {
        state.updatingCategoriesStatus = 'loading';
      })
      .addCase(createNewCategoryAsync.fulfilled, (state) => {
        state.updatingCategoriesStatus = 'idle';
      })
      .addCase(createNewCategoryAsync.rejected, (state) => {
        state.updatingCategoriesStatus = 'failed';
      })
      .addCase(getCategoryFaqsAsync.pending, (state) => {
        state.categoryFaqsStatus = 'loading';
      })
      .addCase(getCategoryFaqsAsync.fulfilled, (state, action) => {
        const uniqueId = Object.keys(action.payload)[0];

        if (state.categoryFaqs[uniqueId]) {
          const stateObj = _.reduce(
            state.categoryFaqs[uniqueId].data,
            function (obj: { [key: string]: Identity.FaqOutput }, param) {
              if (param.id) obj[param.id] = param;

              return obj;
            },
            {}
          );

          const dataObj = _.reduce(
            action.payload[uniqueId].data,
            function (obj: { [key: string]: Identity.FaqOutput }, param) {
              if (param.id) obj[param.id] = param;

              return obj;
            },
            {}
          );

          const totalObj = {
            ...stateObj,
            ...dataObj,
          };

          return {
            ...state,
            categoryFaqsStatus: 'success',
            categoryFaqs: {
              ...state.categoryFaqs,
              [uniqueId]: {
                data: Object.values(totalObj),
                meta: action.payload[uniqueId].meta,
              },
            },
          };
        } else {
          return {
            ...state,
            categoryFaqsStatus: 'success',
            categoryFaqs: {
              ...state.categoryFaqs,
              ...action.payload,
            },
          };
        }
      })
      .addCase(getCategoryFaqsAsync.rejected, (state) => {
        state.categoryFaqsStatus = 'failed';
      })
      .addCase(createFaqEngagementAsync.pending, (state) => {
        state.createFaqEngagement.status = 'loading';
      })
      .addCase(createFaqEngagementAsync.fulfilled, (state, action) => {
        state.createFaqEngagement = { id: action.payload, status: 'success' };
      })
      .addCase(createFaqEngagementAsync.rejected, (state, action) => {
        state.createFaqEngagement = {
          id: action.payload as number,
          status: 'failed',
        };
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
